import { render, staticRenderFns } from "./CurriculumByDocumentoIdentidad.vue?vue&type=template&id=12545e6e&scoped=true&"
import script from "./CurriculumByDocumentoIdentidad.vue?vue&type=script&lang=js&"
export * from "./CurriculumByDocumentoIdentidad.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumByDocumentoIdentidad.vue?vue&type=style&index=0&id=12545e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12545e6e",
  null
  
)

export default component.exports